export const MARK_USER_LOGGED_OUT = 'MARK_USER_LOGGED_OUT';
import { POST_API } from 'middlewares/form';
import root from 'window-or-global';

export function requestLogout () {
  const logoutUrl = (root.MojoUser.user_level == 'Buyer') ? '/' : '/accounts/logout/';
  return {
    [POST_API]: {
      types: ['LOGOUT_REQUEST', 'LOGOUT_REQUEST_SUCCESS', 'LOGOUT_REQUEST_FAILURE'],
      endpoint: '/webapi/logout/',
      payload: {},
      onSuccess: function () {
        window.location.href = logoutUrl;
      },
    },
  };
}

export const HANDLE_GENERATE_NOTIFICATION = 'HANDLE_GENERATE_NOTIFICATION';
function handleGenerateNotification (notification) {
  return {
    type: HANDLE_GENERATE_NOTIFICATION,
    notification,
  };
}

export const NOTIFICATION_BEFORE_DISMISS_REQUEST = 'NOTIFICATION_BEFORE_DISMISS_REQUEST';
export const NOTIFICATION_BEFORE_DISMISS_REQUEST_SUCCESS = 'NOTIFICATION_BEFORE_DISMISS_REQUEST_SUCCESS';
export const NOTIFICATION_BEFORE_DISMISS_REQUEST_FAILURE = 'NOTIFICATION_BEFORE_DISMISS_REQUEST_FAILURE';
export function handleNotificationBeforeDismissHook(beforeDismiss) {
  return {
    [POST_API]: {
      types: [NOTIFICATION_BEFORE_DISMISS_REQUEST, NOTIFICATION_BEFORE_DISMISS_REQUEST_SUCCESS, NOTIFICATION_BEFORE_DISMISS_REQUEST_FAILURE],
      endpoint: beforeDismiss.url,
      payload: () => {
        let key = beforeDismiss.key;
        let value = beforeDismiss.value;
        return {
          [key]: value,
        };
      },
    },
  };
}

export const HANDLE_REMOVE_NOTIFICATION = 'HANDLE_REMOVE_NOTIFICATION';
export function handleRemoveNotification(notification) {
  return {
    type: HANDLE_REMOVE_NOTIFICATION,
    notification,
  };
}

export const HANDLE_REMOVE_ALL_NOTIFICATIONS = 'HANDLE_REMOVE_ALL_NOTIFICATIONS';
export const handleRemoveAllNotifications = () => ({
  type: HANDLE_REMOVE_ALL_NOTIFICATIONS,
});

import md5 from 'md5';
export function showNotification (notification) {
  return dispatch => {
    // TODO find a better way to remove notification in future
    dispatch(handleRemoveNotification());
    if (!notification.id) {
      notification = { ...notification, id: md5(notification.message) };
    }

    dispatch(handleGenerateNotification(notification));

    if (notification.autoDismiss) {
      setTimeout(() => {
        dispatch(handleRemoveNotification(notification));
      }, 5000);
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/actions/GlobalActions.js